import { formatCurrency } from './AuctionSharedUtils';

const StatCard = ({ label, value, accent = '#0d6efd' }) => (
  <div className="card border-0 shadow-sm h-100 rounded-4 overflow-hidden">
    <div style={{ height: 4, background: accent }} />
    <div className="card-body p-3 p-md-4">
      <div className="text-muted small fw-semibold text-uppercase mb-2">{label}</div>
      <div className="fw-bold" style={{ fontSize: '1.5rem', color: '#0f172a', lineHeight: 1.1 }}>{value}</div>
    </div>
  </div>
);

const AuctionSummaryCards = ({ auction = {}, players = [], teams = [], dashboard = false }) => {
  const sold = players.filter((player) => player.status === 'sold').length;
  const unsold = players.filter((player) => player.status === 'unsold').length;
  const cards = [
    { label: 'Total Players', value: auction.totalPlayers ?? players.length, accent: '#2563eb' },
    { label: 'Sold', value: auction.soldCount ?? sold, accent: '#16a34a' },
    { label: 'Unsold', value: auction.unsoldCount ?? unsold, accent: '#dc2626' },
    { label: 'Teams', value: auction.teamsCount ?? teams.length, accent: '#7c3aed' },
    { label: 'Total Spent', value: formatCurrency(auction.totalPurseSpent), accent: '#ea580c' },
    { label: 'Highest Buy', value: auction.highestBuy?.amount != null ? `${auction.highestBuy.playerName || 'Player'}${auction.highestBuy.teamName ? ` · ${auction.highestBuy.teamName}` : ''} · ${formatCurrency(auction.highestBuy.amount)}` : '—', accent: '#0891b2' },
  ];

  if (dashboard) return <div className="pav-metrics">{cards.map((card, index) => <section className={`pav-metric pav-metric--${index}`} key={card.label} aria-label={card.label}><span className="pav-metric-marker" aria-hidden="true" /><div><div className="pav-label">{card.label}</div>{index === 5 && auction.highestBuy?.amount != null ? <><strong className="pav-highest-name">{auction.highestBuy.playerName || 'Player'}</strong><span className="pav-highest-detail">{auction.highestBuy.teamName ? `${auction.highestBuy.teamName} · ` : ''}{formatCurrency(auction.highestBuy.amount)}</span></> : <strong className="pav-value">{card.value}</strong>}</div></section>)}</div>;

  return <div className="row g-3 mb-4">{cards.map((card) => <div className="col-6 col-md-4 col-xl-2" key={card.label}><StatCard {...card} /></div>)}</div>;
};

export default AuctionSummaryCards;
